import api from 'services/api';
import auth from 'services/auth';

export const OAUTH_SOCIAL_EXCHANGE = 'oauthSocial/exchange';

const actions = {
  // Exchanges the authorization `code` returned by the provider for either a logged-in session or status field.
  // Pass `{ isPartnerLogin: true, partnerId }` when the OAuth flow was started from the partner dashboard.
  // `flow` ('login' | 'signup') lets a signup with no matching account mint an identity token.
  exchange(provider, code, { clientId, isPartnerLogin, partnerId, flow } = {}) {
    return {
      type: OAUTH_SOCIAL_EXCHANGE,
      payload: api
        .post(`/oauth-social/${provider}/callback`, {
          code,
          swell_client_id: clientId,
          is_partner_login: isPartnerLogin,
          swell_partner_id: partnerId,
          flow,
        })
        .then((result) => {
          if (result && result.status === 'logged_in' && result.session_id) {
            if (isPartnerLogin) {
              auth.setLoggedInPartnerSessionId(
                result.session_id,
                result.partner_id,
              );
            } else {
              auth.setLoggedInSessionId(result.session_id, result.client_id);
            }
          }
          return result;
        })
        .catch((message) => ({ error: { message } })),
    };
  },
};

export default actions;
